var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_166",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 36.667C22.0833 36.667 24.0347 36.278 25.854 35.5C27.6733 34.722 29.2637 33.6527 30.625 32.292C31.9863 30.9307 33.0557 29.3403 33.833 27.521C34.611 25.7017 35 23.7503 35 21.667H32.208C32.208 25.0557 31.0207 27.9373 28.646 30.312C26.2707 32.6873 23.3887 33.875 20 33.875C16.6113 33.875 13.7293 32.6873 11.354 30.312C8.97933 27.9373 7.792 25.0557 7.792 21.667C7.792 18.2777 8.95167 15.3957 11.271 13.021C13.5903 10.6457 16.4583 9.45801 19.875 9.45801H20.583L17.708 12.333L19.625 14.292L25.917 8.00001L19.625 1.70801L17.708 3.62501L20.708 6.66701H20C17.9167 6.66701 15.9653 7.05567 14.146 7.83301C12.3267 8.61101 10.7363 9.68067 9.375 11.042C8.01367 12.4027 6.94433 13.993 6.167 15.813C5.389 17.6323 5 19.5837 5 21.667C5 23.7503 5.389 25.7017 6.167 27.521C6.94433 29.3403 8.01367 30.9307 9.375 32.292C10.7363 33.6527 12.3267 34.722 14.146 35.5C15.9653 36.278 17.9167 36.667 20 36.667Z",
    fill: "#777777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.d68237847e671406eca3e52d705fd0a2.svg";
export { ForwardRef as ReactComponent };